module.exports = __webpack_public_path__ + "img/disney.9296041a.png";